import { TFunction } from 'i18next'
import { z } from 'zod'

import { MAX_DEPOSIT_INVOICE_PERCENT } from '../../../constants/maxDepositInvoicePercent'
import { DepositInvoiceAmountType } from '../../../enums/depositInvoiceAmountType'
import { DepositDetailsFormSchema } from '../types/depositDetailsFormSchema'

export const getDepositInvoiceDetailsFormSchema = (t: TFunction, quoteAmount: number): DepositDetailsFormSchema => {
  return z
    .object({
      amount: z
        .number({
          /* eslint-disable @typescript-eslint/naming-convention */
          required_error: t('external_invoices.deposit_invoice_details_modal.form.amount.required_error'),
        })
        .min(0.01, t('external_invoices.deposit_invoice_details_modal.form.amount.min_error')),
      type: z.nativeEnum(DepositInvoiceAmountType),
    })
    .superRefine(({ amount, type }, ctx) => {
      const maxAmount = type === DepositInvoiceAmountType.Fixed ? quoteAmount : MAX_DEPOSIT_INVOICE_PERCENT
      if (amount > maxAmount) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['amount'],
          message: t('external_invoices.deposit_invoice_details_modal.form.amount.max_error'),
        })
      }
    })
}
